import { useCallback, useEffect, useState } from 'react';
import { sizes } from '../styles/styles.js';

export function useIsMobileAndTablet() {
  const [_, isSizeIn] = useResize();
  return isSizeIn(['xs', 'mobile', 'tablet']);
}

const handleResize = () => {
  if (window.innerWidth < +sizes.xs.replace('px', '')) {
    return 'xs';
  }
  if (window.innerWidth < +sizes.tablet.replace('px', '')) {
    return 'mobile';
  }
  if (window.innerWidth < +sizes.desktop.replace('px', '')) {
    return 'tablet';
  }
  if (window.innerWidth < +sizes.xl.replace('px', '')) {
    return 'desktop';
  }
  return 'xl';
};

export function useResize(): [
  size: keyof typeof sizes,
  isSizeIn: (checkedSizes: Array<keyof typeof sizes>) => boolean,
] {
  const [size, setSize] = useState<keyof typeof sizes>(() => handleResize());

  const isSizeIn = useCallback((checkedSizes: Array<keyof typeof sizes>) => checkedSizes.includes(size), [size]);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setSize(handleResize());
    });
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return [size, isSizeIn];
}
